import enterprise from "./enterprise";
import promote from "./promote";
import user from "./user";

/**
 * 华博特项目接口文档
 */
export default {
  enterprise,
  promote,
  user,
};
